import { put } from 'redux-saga/effects'
import { IPcr } from '../../pcr/store/pcr.types'
import { setTripInformation } from '../store/tripInformation.actions'

export function* getTripInformation(pcrDoc: IPcr) {
  const tripInformation = pcrDoc.patient?.tripInformation
  if (pcrDoc.dispatchId) {
    tripInformation.dispatchID = pcrDoc.dispatchId
  }
  if (tripInformation && Object.keys(tripInformation).length !== 0) {
    yield put(setTripInformation(tripInformation))
  }
}
